import "./nav.css"
import {useEffect, useState} from "react";
import {GiHamburgerMenu} from "react-icons/gi";
import logo from "../../../assets/img/logo/logo.png";
import ProfileBlock from "./Profile";
import {useDrawer} from "../../../redux/Reducers/DrawerReducer";
import Icon from "../../../components/Icon/Icon";
import {Link} from "react-router-dom";
import LanguageSelectionModal from "../../../Modals/language-selection-modal/language-selection-modal";
import {ImEarth} from "react-icons/im";


export default function MainHeader({enabledFixHeaderFix, ...props}) {
    const [isFixed, setIsFixed] = useState(false);
    const {actions} = useDrawer();
    const [isLanguageModalOpen, setIsLanguageModalOpen] = useState(false);

    function handleScroll() {
        if (enabledFixHeaderFix === false) return;
        if (window.scrollY > 50) { // Adjust the scroll threshold as needed
            setIsFixed(true)
        } else {
            setIsFixed(false)
        }
    }

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        }

    }, [])


    return (<div
        className={`${isFixed || enabledFixHeaderFix === false ? "fixed bg-white top-0 z-50 up-to-down-animation " : ""}     w-full nav-component-position `}>
        <div className={"flex justify-center items-center shadow-sm dark:shadow-none   "}>

            <LanguageSelectionModal
                isBoxOpen={isLanguageModalOpen}
                setIsBoxOpen={setIsLanguageModalOpen}
            />
            <div className={"fixed    dark:bg-darkBgSecondary   nav-common "}>


            </div>
            <div
                className={" rounded-b-md lg:rounded-b-lg text-gray-900 dark:text-white font-medium  flex flex-col lg:gap-4 lg:flex-row   z-[80] nav-common "}
            >

                <div className={"flex items-center flex-1 justify-center flex-row"}>
                    <GiHamburgerMenu onClick={actions.toggleDrawer}
                                     className={"text-2xl cursor-pointer text-brand-900 "}/>

                    <Link
                        to={"/"}
                        className={" flex-1 text-xl self-start mt-1 ml-2  lg:text-2xl flex  cursor-pointer items-center flex-row gap-2"}>
                        <img src={logo} className={"w-auto h-8"} alt={"logo"}/>

                    </Link>

                    <div className={"flex-1  flex"}>
                        <div className={"flex flex-1 justify-end   items-center mr-5  flex-row gap-4"}>


                            <Link
                                to={"/practice"}
                                className={"inline-flex  gap-1 justify-center items-center"}>
                                <Icon name={"support"}/>

                                <p className={"hidden lg:flex font-normal cursor-pointer"}>
                                    Practice
                                </p>

                            </Link>

                            <Link
                                to={"/notifications"}
                                className={"inline-flex  gap-1 justify-center items-center"}>
                                <Icon name={"bell"}/>
                                <p className={" hidden lg:flex  font-normal cursor-pointer"}>
                                    Notifications
                                </p>

                            </Link>
                            <button
                                title={"Language"}
                                onClick={() => setIsLanguageModalOpen(true)}
                                className={"inline-flex  gap-1 justify-center items-center"}>
                                <ImEarth className={"text-bawa"}/>
                                {/*<p className={"font-normal cursor-pointer"}>*/}
                                {/*    Language*/}
                                {/*</p>*/}
                            </button>
                        </div>
                    </div>

                    <ProfileBlock className={"flex lg:hidden"}/>

                </div>


                <ProfileBlock className={"hidden lg:flex"}/>


            </div>

        </div>
    </div>)
}
